var map = {
	"./animoji-1.png": 10907,
	"./animoji-10.png": 71801,
	"./animoji-11.png": 42370,
	"./animoji-2.png": 14350,
	"./animoji-3.png": 13077,
	"./animoji-4.png": 79599,
	"./animoji-5.png": 26317,
	"./animoji-6.png": 36130,
	"./animoji-7.png": 3161,
	"./animoji-8.png": 10889,
	"./animoji-9.png": 85523,
	"./animoji.png": 30127
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13545;